import { Cancel, Edit, List, Save } from '@mui/icons-material';
import { Box, Button, Divider } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceHeading } from '~/components/SolaForceHeading';
import { useVacationBalanceDataForm } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/VacationBalanceData/useVacationBalanceDataForm';
import { VacationAndSupplementalBalances } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/VacationBalanceData/VacationAndSupplementalBalances';
import { YearlyVacationBalanceTable } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/VacationBalanceData/YearlyVacationBalanceTable';

import { useSxStyles } from './useStyles';
import { useVacationBalanceData } from './useVacationBalanceData';
import { VacationDaysHistoryDialog } from './VacationDaysHistoryDialog/VacationDaysHistoryDialog';

export const VacationBalanceData = () => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const {
    defaultData,
    vacHistoryTableData,
    bnEnableVacBank,
    vacBankType1,
    vacBankType2,
    vacBankType3,
    openAbsHistoryDialog,
    isAbsHistoryDialogOpen,
    closeAbsHistoryDialog,
    extraVacEnum,
    editMode,
    setEditMode,
    vacBankEnum,
    hasEditAccess,
    selectedEmployeeId,
    onUpdate,
  } = useVacationBalanceData();

  const { control, handleFormSubmit, handleFormReset } =
    useVacationBalanceDataForm({
      defaultData,
      setEditMode,
      selectedEmployeeId,
      onUpdate,
    });

  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        <SolaForceHeading heading={t('vacationBalances')}>
          {hasEditAccess && (
            <>
              {editMode ? (
                <>
                  <Button
                    onClick={handleFormSubmit}
                    startIcon={<Save />}
                    data-testid="vacBalance-button-save"
                  >
                    {t('laSave')}
                  </Button>
                  <Button
                    onClick={handleFormReset}
                    startIcon={<Cancel />}
                    data-testid="vacBalance-button-cancel"
                  >
                    {t('laCancel')}
                  </Button>
                </>
              ) : (
                <Button
                  onClick={() => setEditMode((prevValue) => !prevValue)}
                  startIcon={<Edit />}
                  data-testid="vacBalance-button-edit"
                >
                  {t('laEdit')}
                </Button>
              )}
              <Divider orientation={'vertical'} variant={'middle'} flexItem />
            </>
          )}
          <Button onClick={() => openAbsHistoryDialog()} startIcon={<List />}>
            {t('laHistory')}
          </Button>
        </SolaForceHeading>
        <Box sx={sxStyles.container}>
          <VacationAndSupplementalBalances
            defaultData={defaultData}
            control={control}
            editMode={editMode}
            bnEnableVacBank={bnEnableVacBank}
            vacBankType1={vacBankType1}
            vacBankType2={vacBankType2}
            vacBankType3={vacBankType3}
            extraVacEnum={extraVacEnum}
            vacBankEnum={vacBankEnum}
          />
          <YearlyVacationBalanceTable />
        </Box>
      </form>

      <VacationDaysHistoryDialog
        open={isAbsHistoryDialogOpen}
        onClose={closeAbsHistoryDialog}
        bnEnableVacBank={bnEnableVacBank}
        vacHistoryTableData={vacHistoryTableData}
      />
    </>
  );
};
